import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "307",
  "slug": "spot-morocco-from-satellite-imagery",
  "title": "How to Recognise Morocco in Satellite Images",
  "excerpt": "The Atlas Mountains run across Morocco, separating parts of the Atlantic-facing lowlands from drier interior terrain.",
  "date": "2026-03-30",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/morocco.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "The Atlas Mountains run across Morocco, separating parts of the Atlantic-facing lowlands from drier interior terrain. The Rif lie in the north beside the Mediterranean. Agricultural plains and mountain valleys offer different clues from the dry land farther southeast."
    },
    {
      "type": "heading",
      "text": "The Atlas between the Atlantic and the interior"
    },
    {
      "type": "paragraph",
      "text": "Compare the Atlantic plain with the land southeast of the High Atlas. The overview includes the wider region; it does not depict or settle political boundaries."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Spain and Algeria share Mediterranean and dry mountain landscapes. Soil colour and flat-roofed buildings are not enough. Establish which side of a mountain belt a view occupies and whether a nearby coast faces the Atlantic or Mediterranean."
    }
  ],
  "imageAlt": "Morocco regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
